<template>
  <div id="dplayer"></div>
</template>

<script>
//import "dplayer/dist/DPlayer.min.css";
import DPlayer from "dplayer/dist/DPlayer.min.js";

// import flvjs from "flv.js";
// import Hls from "hls.js";

// window.flvjs = flvjs;
// window.Hls = Hls;

export default {
  name: "VideoPlayer",
  data() {
    return {
      options: {
        container: null,
        video: {
          url: ""
        },
        subtitle: null,
        autoplay: false
      },
      player: null
    };
  },
  props: {
    url: String,
    vttUrl: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    this.options.container = document.getElementById("dplayer");
    if (this.vttUrl) {
      this.options.subtitle = {
        url: this.vttUrl,
        type: "webvtt",
        fontSize: "25px",
        bottom: "10%",
        color: "#b7daff"
      };
    }
    this.player = new DPlayer(this.options);
    this.player.switchVideo({
      url: this.url
    });
  },
  destroyed() {
    this.player.destroy();
  }
};
</script>

<style>
@media screen and (min-width: 992px) {
  .dplayer {
    margin: 0 auto;
    height: 80vh;
  }
}

@media screen and (max-width: 992px) {
  .dplayer {
    margin: 0 auto;
    height: 35vh;
  }
}
</style>